import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import * as navigation from "../utils/navigation";
import { toast } from "../utils/toast";
import { useIntl } from "react-intl";

// Pega a URL atual do navegador para definir a URL da API dinamicamente.
let url = window.location.href;

// Lógica dinâmica:
// - Se a URL contiver "localhost", usa a API local.
// - Caso contrário, substitui "web" ou "plataforma" por "api" para apontar para o backend correto.
export const serverDefaultUrl = url.includes("localhost")
  ? "http://localhost/"
  : url.replace("web", "api").replace("plataforma", "api");

export const apiDefaultUrl = serverDefaultUrl + "api";

const api = axios.create({
  baseURL: apiDefaultUrl,
});

/**
 * Interceptor para incluir o idioma (locale) no cabeçalho de cada requisição.
 */
api.interceptors.request.use(async (config) => {
  const locale = await AsyncStorage.getItem("lang");
  if (locale) {
    // Garante que o locale existe antes de tentar usá-lo.
    config.headers["Accept-Language"] = locale.replace("-", "_");
  }
  return config;
});

/**
 * Interceptor para tratar respostas de erro, especialmente o erro 401 (Não Autorizado),
 * que indica que a sessão do usuário expirou.
 */
api.interceptors.response.use(
  (request) => request,
  (error) => {
    const { response, config } = error;

    // Se o status for 401 e não for uma tentativa de login/logout, desloga o usuário.
    if (
      response?.status === 401 &&
      !config?.url.includes("login") &&
      !config?.url.includes("logout")
    ) {
      expire_session()
        .then(() => navigation.navigate("Login"))
        .catch(() => navigation.navigate("Login"));
    }
    return Promise.reject(error);
  }
);

// Função para deslogar o usuário e limpar os dados da sessão.
async function expire_session() {
  // NOTA: useIntl() só pode ser chamado dentro de um componente React.
  // Para usar aqui, seria necessário um setup mais complexo.
  // Por enquanto, a mensagem de erro será genérica ou virá de um serviço de tradução.
  const genericMessage = "Sua sessão expirou. Por favor, faça login novamente.";

  return api
    .post("auth/logout")
    .then((resp) => {
      AsyncStorage.removeItem("token");
      delete api.defaults.headers.common["Authorization"];
      toast(genericMessage, "#DA1414");
      return resp;
    })
    .catch((err) => {
      toast(genericMessage, "#DA1414");
      AsyncStorage.removeItem("token");
      return err;
    });
}

export default api;
